export enum AccountMembershipRole {
  Admin = 'ACCOUNT_MEMBERSHIP_ROLE_ADMIN',
  Publication = 'ACCOUNT_MEMBERSHIP_ROLE_PUBLICATION',
  Ecom = 'ACCOUNT_MEMBERSHIP_ROLE_ECOM',
  Ats = 'ACCOUNT_MEMBERSHIP_ROLE_ATS',
  CompanyProfile = 'ACCOUNT_MEMBERSHIP_ROLE_COMPANY_PROFILE',
  Wallet = 'ACCOUNT_MEMBERSHIP_ROLE_WALLET_MANAGEMENT',
}
